import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { createBrowserHistory } from "history";
import { useDispatch, useSelector } from "react-redux";
import {
  updateSetting,
  updateExchangeSettingsDetails,
  updatePaymentSettings,
} from "../../redux/slices";
import {
  storeSettingTypes,
  exchangeSettingsActionTypes,
  paymentSettingTypes,
} from "../../redux/utils";
import { Form, WidgetMain } from "../";
import { useAppContext } from "../../contexts";
import { useHardCode, useAPI } from "../../hooks";
import { Toast, FullPageLoader } from "..";

export const Main = () => {
  const search = useLocation().search;
  const history = createBrowserHistory();
  const current_domain = window.location.hostname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { SHOPIFY_SHOP_OBJECT } = useHardCode();
  const { GET_STORE_CONFIG_SHOPIFY_STORE_NAME_API } = useAPI();
  let store_subdomain;


  if (current_domain === "localhost" || current_domain === "18.206.140.255") {
    store_subdomain =
      new URLSearchParams(search).get("store_subdomain") ||
      "devstoresaaraindia2";
  } else {
    store_subdomain =
      current_domain.toLowerCase().split(".")[0] === "www"
        ? current_domain.split(".")[1]
        : current_domain.split(".")[0];
  }


  const auto_order_id = new URLSearchParams(search).get("order_id");
  const auto_cid = new URLSearchParams(search).get("cid");
  const {
    setLogoURL,
    setBaseURL,
    setIsAutoFill,
    isInternalServerError,
    setIsInternalServerError,
    setIsPageLoading,
    isPageLoading,
  } = useAppContext();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const shopifyStoreName = SHOPIFY_SHOP_OBJECT;
  useEffect(() => {
    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
        value: null,
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_SELECTED_PRODUCT_NAME,
        value: null,
      })
    );
  });

  useEffect(() => {
    dispatch(
      updateSetting({
        key: storeSettingTypes.UPDATE_IS_JOHN_DOE_TEST_MODE,
        value: false,
      })
    );

    dispatch(
      updatePaymentSettings({
        key: paymentSettingTypes.UPDATE_CUSTOMER_UPI_ID,
        value: null,
      })
    );
    dispatch(
      updatePaymentSettings({
        key: paymentSettingTypes.UPDATE_ACCOUNT_NUMBER,
        value: null,
      })
    );
    dispatch(
      updatePaymentSettings({
        key: paymentSettingTypes.UPDATE_IFSC,
        value: null,
      })
    );
    dispatch(
      updatePaymentSettings({
        key: paymentSettingTypes.UPDATE_BENEFICIARY_NAME,
        value: null,
      })
    );

    (async () => {
      try {
        if (store_subdomain) {
          dispatch(
            updateSetting({
              key: storeSettingTypes.UPDATE_SUBDOMAIN,
              value: store_subdomain,
            })
          );

          const response = await fetch(
            `${GET_STORE_CONFIG_SHOPIFY_STORE_NAME_API}${shopifyStoreName}`
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();

          if (!data.error) {
            setIsPageLoading(false);
            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_TEST_ORDER,
                value: data?.test_order,
              })
            );
            dispatch(
              updateSetting({
                key: storeSettingTypes.IS_CHATGPT_ENABLED,
                value: data?.is_chatgpt_enabled,
              })
            );
            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_PLATFORM,
                value: data?.platform || "shopify",
              })
            );
            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_BRAND_LOGO,
                value: data?.logo_url,
              })
            );

            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_BASE_URL,
                value: data?.base_url,
              })
            );

            if (auto_order_id) {
              dispatch(
                updateSetting({
                  key: storeSettingTypes.UPDATE_AUTO_ORDER_ID,
                  value: auto_order_id?.trim(),
                })
              );
            }

            if (auto_cid) {
              dispatch(
                updateSetting({
                  key: storeSettingTypes.UPDATE_AUTO_CID,
                  value: auto_cid,
                })
              );
            }

            if (auto_order_id && auto_cid) {
              setIsAutoFill(true);
            }

            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_STORE_UNIQUE_ID,
                value: data?.store_unique_id,
              })
            );

            setLogoURL(data?.logo_url);
            setBaseURL(data?.base_url);

            /* Theme setting */
            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_THEME_CONFIG_OTHERS,
                value: data?.theme_config.other,
              })
            );
            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_THEME_CONFIG,
                value: data?.theme_config.en /*Default is English */,
              })
            );
            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_THEME_CONFIG_DA,
                value: data?.theme_config.da,
              })
            );

            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_THEME_CONFIG_DE,
                value: data?.theme_config.de,
              })
            );

            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_THEME_CONFIG_EN,
                value: data?.theme_config.en,
              })
            );

            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_THEME_CONFIG_ES,
                value: data?.theme_config.es,
              })
            );

            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_THEME_CONFIG_IT,
                value: data?.theme_config.it,
              })
            );

            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_STORE_NAME,
                value: data?.store_name,
              })
            );
            dispatch(
              updateSetting({
                key: storeSettingTypes.UPDATE_STORE_PLAN,
                value: data?.store_plan,
              })
            );
          }
        }

        dispatch(
          updateSetting({
            key: storeSettingTypes.UPDATE_IS_404,
            value: false,
          })
        );
      } catch (error) {
        setIsPageLoading(false);
        if (error.message.includes('500')) {
          setIsInternalServerError(true);
        } else if (error.message.includes('400')) {
          dispatch(
            updateSetting({
              key: storeSettingTypes.UPDATE_IS_404,
              value: true,
            })
          );
          navigate("/Page-Not-Found");
        }
        else {
          console.error("Unhandled error status:", error?.response?.status);
          console.error("Full error:", error);
        }
      }
    })();
  
  }, []);

  /* if back button press it will navigate to home page */
  useEffect(() => {
    return history.listen(() => {
      if (history.action === "POP") {
        navigate("/");
      }
    });
  }, [history, navigate]);
  return (
    <>
      {isPageLoading ? (
        <FullPageLoader />
      ) : (
        <main className="saara__main">
          {isInternalServerError && <Toast type="error" />}
          <div className="saara__container">
            <div className="main__content">
              <div className="main__text">
                <div className="main__logo">
                  <h1 className="main__title">
                    {`${storeConfigState?.themeConfig?.landing_page_left_title}`}
                  </h1>
                  <p
                    className="main__description"
                    dangerouslySetInnerHTML={{
                      __html:
                        storeConfigState?.themeConfig?.others
                          ?.landing_page_text ||
                        storeConfigState?.themeConfig
                          ?.landing_page_left_content,
                    }}
                  ></p>

                  {storeConfigState?.themeConfigOthers?.return_policy_url && (
                    <p className="privacy_policy">
                      {storeConfigState?.themeConfig?.please_read_our}{" "}
                      <a
                        href={
                          storeConfigState?.themeConfigOthers?.return_policy_url
                        }
                        className="return_policy_url"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {
                          storeConfigState?.themeConfig
                            ?.return_and_exchange_policies
                        }
                      </a>{" "}
                      {storeConfigState?.themeConfig?.before_proceeding}
                    </p>
                  )}
                </div>
              </div>
              <WidgetMain
                store_subdomain={store_subdomain}
                shopifyStoreName={shopifyStoreName}
              />
              <Form />
            </div>
          </div>
        </main>
      )}
    </>
  );
};
